module.exports = __webpack_public_path__ + "img/ico-sns-facebook.fab038ae.svg";